export const cellThemeOptions = {
  blue: "blue",
  green: "green",
  red: "red",
  mango: "mango",
  indigo: "indigo",
  gray: "gray",
};

export const cellBorderOptions = {
  zero: "-0",
  thin: "",
  thick: "-2",
};
export const cellCornerOptions = {
  none: "none",
  small: "sm",
  large: "lg",
  xlarge: "xl",
};

export const highlightingLangOptions = {
  none: { label: "None", prismValue: "text" },
  bash: { label: "Bash", prismValue: "bash" },
  c: { label: "C", prismValue: "c" },
  cpp: { label: "C++", prismValue: "cpp" },
  csharp: { label: "C#", prismValue: "csharp" },
  coffeescript: { label: "CoffeeScript", prismValue: "coffeescript" },
  css: { label: "CSS", prismValue: "css" },
  dart: { label: "Dart", prismValue: "dart" },

  elixir: { label: "Elixir", prismValue: "elixir" },
  fortran: { label: "Fortran", prismValue: "fortran" },
  go: { label: "Go", prismValue: "go" },
  graphql: { label: "GraphQl", prismValue: "graphql" },
  groovy: { label: "Groovy", prismValue: "groovy" },
  handlebars: { label: "Handlebars", prismValue: "handlebars" },
  haskell: { label: "Haskell", prismValue: "haskell" },
  html: { label: "HTML", prismValue: "markup" },
  java: { label: "Java", prismValue: "java" },
  javascript: { label: "JavaScript", prismValue: "javascript" },
  json: { label: "JSON", prismValue: "json" },
  jsx: { label: "JSX", prismValue: "jsx" },
  koltin: { label: "Koltin", prismValue: "koltin" },
  latex: { label: "Latex", prismValue: "latex" },
  markdown: { label: "Markdown", prismValue: "markdown" },
  mongodb: { label: "MongoDB", prismValue: "mongodb" },
  matlab: { label: "Matlab", prismValue: "matlab" },
  objectivec: { label: "Objective-C", prismValue: "objectivec" },
  pascal: { label: "Pascal", prismValue: "pascal" },
  perl: { label: "Perl", prismValue: "perl" },
  php: { label: "PHP", prismValue: "php" },
  python: { label: "Python", prismValue: "python" },
  r: { label: "R", prismValue: "r" },
  regex: { label: "Regex", prismValue: "regex" },
  ruby: { label: "Ruby", prismValue: "ruby" },
  rust: { label: "Rust", prismValue: "rust" },
  sass: { label: "Sass", prismValue: "sass" },
  scala: { label: "Scala", prismValue: "scala" },
  sql: { label: "SQL", prismValue: "sql" },
  swift: { label: "Swift", prismValue: "swift" },
  typescript: { label: "TypeScript", prismValue: "typescript" },
  yalm: { label: "Yaml", prismValue: "yaml" },
};
